// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"patient_listWrapper__2OqvY","wt":"patient_wt__yj5Dt","md":"patient_md___IctY","r1":"patient_r1__1sJwW","r2":"patient_r2__1JjQH"};